var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 25,
    viewBox: "0 0 33 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.9863 25H3.98633C3.15753 25 2.36267 24.6708 1.77662 24.0847C1.19057 23.4987 0.861328 22.7038 0.861328 21.875V2.98906C0.896379 2.18405 1.24103 1.42369 1.82333 0.86672C2.40562 0.309754 3.18055 -0.000761311 3.98633 1.40175e-06H28.9863C29.8151 1.40175e-06 30.61 0.329241 31.196 0.915293C31.7821 1.50134 32.1113 2.2962 32.1113 3.125V21.875C32.1113 22.7038 31.7821 23.4987 31.196 24.0847C30.61 24.6708 29.8151 25 28.9863 25ZM3.98633 6.04375V21.875H28.9863V6.04375L16.4863 14.375L3.98633 6.04375ZM5.23633 3.125L16.4863 10.625L27.7363 3.125H5.23633Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMail);
export default __webpack_public_path__ + "static/media/icon-mail.55bd380476fc0a14d67e089f3bb5a926.svg";
export { ForwardRef as ReactComponent };